// extracted by mini-css-extract-plugin
module.exports = {"footerNavMenu":"footer_footerNavMenu__ZOuig"};